import script from "./createDataSource.vue?vue&type=script&setup=true&lang=js"
export * from "./createDataSource.vue?vue&type=script&setup=true&lang=js"

import "./createDataSource.vue?vue&type=style&index=0&id=1c9fcf38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c9fcf38"]])

export default __exports__